"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiples = exports.emptyNgram = exports.unknown = exports.reasonForVisit = exports.duplicates = exports.sentenceAndNgram = void 0;
var utils_1 = require("../utils/utils");
var _baseCase = {
    caseRuns: [{}]
};
var _baseArtifact = {
    procedures: {
        evidence: [],
        codes: []
    },
    diagnoses: {
        evidence: [],
        codes: []
    },
    modifiers: {
        evidence: [],
        codes: []
    }
};
var baseCPT = {
    procedure_code: "73030",
    units: 1.0,
    automate: true,
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0c42",
    evidence: [],
    modifiers: {
        evidence: [],
        automate: true,
        codes: []
    },
    diagnoses: {
        evidence: [],
        codes: []
    }
};
var makeCode = function (orig) {
    return function (mixin) {
        var code = __assign(__assign({}, orig), mixin);
        return code;
    };
};
var makeCPT = makeCode(baseCPT);
var makeArtifact = function (artifact) {
    var base = (0, utils_1.cloneDeep)(_baseCase);
    // @ts-ignore
    base.caseRuns[0].artifacts = [artifact];
    return base;
};
var makeProcedureArtifact = function (partialCode) {
    return makeArtifact({
        procedures: {
            codes: [makeCPT(__assign({}, partialCode))]
        }
    });
};
exports.sentenceAndNgram = makeProcedureArtifact({
    evidence: [
        {
            feature: {
                uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-095jj583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected ngram",
                        level: "ngram"
                    },
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-095ii583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
});
exports.duplicates = makeProcedureArtifact({
    evidence: [
        {
            feature: {
                uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-095kk583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence"
                    },
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-777583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence"
                    },
                    {
                        feature: {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                            type: "categorical",
                            category: "Spine",
                            field: "body_region"
                        },
                        type: "Categorical",
                        score: 0.04377880184331798
                    },
                    {
                        feature: {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                            type: "categorical",
                            category: "Spine",
                            field: "body_region"
                        },
                        type: "Categorical",
                        score: 0.04377880184331798
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
});
exports.reasonForVisit = makeProcedureArtifact({
    evidence: [
        {
            feature: {
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_reasonforvisit",
                spans: []
            },
            type: "Ngram",
            score: 1.8524357683146777
        },
        {
            feature: {
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "exam_type",
                spans: []
            },
            type: "Ngram",
            score: 1.8524357683146888
        },
        {
            feature: {
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_reasonforvisit",
                spans: []
            },
            type: "Ngram",
            score: 1.8524357683146999
        }
    ]
});
exports.unknown = makeProcedureArtifact({
    evidence: [
        {
            details: {
                feature: {
                    type: "ngram",
                    ngram: "chest pain",
                    field: "raw_reasonforvisit",
                    slop: 2,
                    in_order: true
                },
                score: 0.21478298151125555,
                type: "Unknown"
            },
            type: "Unknown"
        }
    ]
});
exports.emptyNgram = makeProcedureArtifact({
    evidence: [
        {
            feature: {
                uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: []
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
});
exports.multiples = makeProcedureArtifact({
    evidence: [
        {
            feature: {
                uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "No endoleaks are detected",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 812,
                        end: 837,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-095ll583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence"
                    },
                    {
                        start: 842,
                        end: 855,
                        uuid: "cce97bb3-9d74-4d1f-b0e3-777583ddc3",
                        document_id: 234325,
                        content: "No endoleaks are detected sentence",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
});
//# sourceMappingURL=transformers.fixtures.js.map